import React from 'react';
import Folder from 'material-ui/svg-icons/file/folder';
import ContentIcon from './ContentIcon';

const FolderIcon = ({ icon, ...rest }) => (
  <ContentIcon
    outer={Folder}
    inner={icon}
    {...rest}
  />
);

export default FolderIcon;
